import React from "react";
import Select, { MultiValue } from "react-select";

export type MultiSelectOption = {
    value: string;
    label: string;
};

type MultiSelectInputProps = {
    label?: string;
    name: string;
    value: string[];
    options: MultiSelectOption[];
    placeholder?: string;
    onChange: (value: string[]) => void;
};

const MultiSelectInput = ({
    label,
    name,
    value,
    options,
    placeholder = "Select options...",
    onChange,
}: MultiSelectInputProps) => {
    const selectedOptions = options.filter((option) => value.includes(option.value));

    return (
        <div className="flex flex-col gap-1 sm:w-64">
            {label && <label className="text-sm font-semibold" htmlFor={name}>{label}</label>}
            <Select
                inputId={name}
                name={name}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                options={options}
                value={selectedOptions}
                placeholder={placeholder}
                onChange={(selected: MultiValue<MultiSelectOption>) => {
                    onChange(selected.map((option) => option.value));
                }}
                classNamePrefix="react-select"
                styles={{
                    control: (base) => ({
                        ...base,
                        minHeight: "42px",
                        borderColor: "#d1d5db",
                        boxShadow: "none",
                    }),
                    menu: (base) => ({
                        ...base,
                        zIndex: 30,
                    }),
                }}
            />
        </div>
    );
};

export default MultiSelectInput;
